import { success, loading, handleErrorException } from 'State/actions';

import * as types from './types';

export const getSavedExports = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.EXPORTS_LOADING, true));
      const response = await MPWWebApi.getGeneric(
        'Export/NewYork/Sirs/Exports'
      );
      dispatch(success(types.GET_SAVED_EXPORTS, response.data.Data));
    } catch (e) {
      handleErrorException(e, types.GET_SAVED_EXPORTS_ERROR, {
        Title: 'Error',
        Message: 'Could not load saved exports.',
      });
    } finally {
      dispatch(loading(types.EXPORTS_LOADING, false));
    }
  };
};

export const deleteSavedExport = (exportId) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.EXPORTS_LOADING, true));
    try {
      await MPWWebApi.postGenericInsertUpdate(
        `Export/NewYork/Sirs/Exports/Delete/${exportId}`
      );
      dispatch(success(types.SAVED_EXPORT_DELETE_SUCCESSFUL, true));
    } catch (e) {
      handleErrorException(e, types.GET_SAVED_EXPORTS_ERROR, {
        Title: 'Error',
        Message: 'Could not delete saved export.',
      });
    } finally {
      dispatch(loading(types.EXPORTS_LOADING, false));
    }
  };
};

export const clearError = () => ({
  type: types.SAVED_EXPORTS_CLEAR_ERROR,
});

export const setDeleteSuccessful = (success) => ({
  type: types.SAVED_EXPORT_DELETE_SUCCESSFUL,
  payload: success,
});



// WEBPACK FOOTER //
// ./src/pages/newyorksirsexport/state/exportlist/actions.js